<button mat-icon-button [matMenuTriggerFor]="triggerFor()" [attr.aria-label]="ariaLabelDisplay()">
  <mat-icon svgIcon="bell" muloSvgViewbox [class.is-animated]="count() > 0"></mat-icon>
  @if (count() > 0) {
    <mulo-badge size="medium">{{ count() > 99 ? '99+' : count() }}</mulo-badge>
  }
</button>
